import * as React from 'react';
import { Box, ParagraphText, UtilityText } from '@leagueplatform/genesis-core';

export const PolicyInformationItem: React.FC<{
  label: string;
  value: string;
}> = ({ label, value }) => (
  <Box as="li">
    <UtilityText
      css={{
        typography: '$overline',
        textTransform: 'uppercase',
      }}
    >
      {label}
      <ParagraphText
        css={{ display: 'block', marginBlockStart: '$half' }}
        as="span"
      >
        {value}
      </ParagraphText>
    </UtilityText>
  </Box>
);
